import { PendingVendorSplit } from "./Splits/AddVendorSplitDialog";
import { PendingBuyerSplit } from "./Splits/AddBuyerSplitDialog";
import { SaleType } from "constants/sale";
import { PricingTypes } from "constants/pricingTypes";

export interface SaleFormValues {
  date: string;
  sale_title: string;
  sale_sub_type_id: number | null;
  sale_round_id: string | null;
  sale_type: SaleType | null;
  notes: string;
  pricing_type_id: number;
  species_id: number | null;
  deployment_ids: number[];
  deployment_sales: Partial<DeploymentSaleCreate>[];
}

export interface ConsignmentFormValues {
  billing_reference: string | null;
  vendor_id: string | null;
  vendor_property_id: string | null;
}

export interface SaleLotFormValues {
  // WHO
  buyer_id: string | null;
  destination_property_id: string | null;
  buyer_way: { id: number; name: string } | null;
  // WHAT
  quantity: number | null;
  quantity_progeny: number;
  product_id: string | null;
  sex_id: number | null;
  age_id: number | null;
  breed_id: number | null;
  dentitionId: number | null;
  marks: Mark[];
  labels: string[];
  draftingAttributes: { tagNumber?: string; animalName?: string } | null;
  exemption_id: number | null;
  estimatedAverageWeightId: number | null;
  dressingRangeId: number | null;
  grade_id: number | null;
  category_id: number | null;
  note: string;
  // PRICE
  pricing_type_id: number | null;
  unit_price: string | null;
  total_mass_grams: number;
  quantity_delivered: number | null;
  reservePrice: number | null;
  invoiceToBusinessId: string | null;
}

export interface SkinLotFormValues {
  quantity: number | null;
  unitPrice: string | null;
  pricing_type_id: number;
  total_mass_grams: number;
}

export const defaultSkinLot: SkinLotFormValues = {
  quantity: null,
  unitPrice: null,
  pricing_type_id: PricingTypes.PER_HEAD,
  total_mass_grams: 0,
};

export interface MobileTransactionalCreateSaleFormValues {
  sale: SaleFormValues;
  consignment: ConsignmentFormValues;
  saleLot: SaleLotFormValues;
  vendorSplit: PendingVendorSplit | null;
  buyerSplit: PendingBuyerSplit | null;
  skinLots: SkinLotFormValues[];
}

export const defaultSaleLot: SaleLotFormValues = {
  buyer_id: null,
  destination_property_id: null,
  buyer_way: null,
  quantity: null,
  quantity_progeny: 0,
  product_id: null,
  sex_id: null,
  age_id: null,
  breed_id: null,
  dentitionId: null,
  marks: [],
  labels: [],
  draftingAttributes: null,
  exemption_id: null,
  estimatedAverageWeightId: null,
  dressingRangeId: null,
  grade_id: null,
  category_id: null,
  note: "",
  pricing_type_id: 2,
  unit_price: null,
  total_mass_grams: 0,
  quantity_delivered: null,
  reservePrice: null,
  invoiceToBusinessId: null,
};

export const defaultValues: MobileTransactionalCreateSaleFormValues = {
  sale: {
    date: "",
    sale_title: "",
    sale_sub_type_id: null,
    sale_round_id: null,
    sale_type: null,
    notes: "",
    pricing_type_id: 2,
    species_id: null,
    deployment_ids: [],
    deployment_sales: [],
  },
  consignment: {
    billing_reference: null,
    vendor_id: null,
    vendor_property_id: null,
  },
  saleLot: defaultSaleLot,
  vendorSplit: null,
  buyerSplit: null,
  skinLots: [defaultSkinLot],
};
